import { ColumnDefinition } from 'features/gridReport/models';

export function getFilterableColumns(
  columns: ColumnDefinition[]
): ColumnDefinition[] {
  return columns.filter(item => item.filterable);
}
